import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllProductsShop, deleteProduct } from "../../redux/actions/product";
import ProductCard from "../Cards/ProductCard";
import {Loader} from '../Layout/Loader'
import "./AllProducts.scss";

const AllProducts = () => {
  const dispatch = useDispatch();
  const { seller } = useSelector((state) => state.seller);
  const { products, isLoading, error  } = useSelector((state) => state.products);

  const [searchTerm, setSearchTerm] = useState("");
  const [sortOption, setSortOption] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const productsPerPage = 20;

  useEffect(() => {
    if (seller && seller._id) {
      dispatch(getAllProductsShop(seller._id));
    }
  }, [dispatch, seller]);

  const filteredProducts = Array.isArray(products)
  ? products.filter((product) =>
      product.name.toLowerCase().includes(searchTerm.toLowerCase())
    )
  : [];
  const sortedProducts = [...filteredProducts].sort((a, b) => {
    switch (sortOption) {
      case "price-asc":
        return a.originalPrice - b.originalPrice;
      case "price-desc":
        return b.originalPrice - a.originalPrice;
      case "name-asc":
        return a.name.localeCompare(b.name);
      case "name-desc":
        return b.name.localeCompare(a.name);
      default:
        return 0;
    }
  });

  const indexOfLastProduct = currentPage * productsPerPage;
  const indexOfFirstProduct = indexOfLastProduct - productsPerPage;
  const currentProducts = sortedProducts.slice(indexOfFirstProduct, indexOfLastProduct);

  const totalPages = Math.ceil(sortedProducts.length / productsPerPage);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const handleSortChange = (e) => {
    setSortOption(e.target.value);
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleDeleteProduct = (productId) => {
    dispatch(deleteProduct(productId));
  };

  return (
    <div className="all-products-container">
      <h2 className="titleer">Всі продукти</h2>

      <div className="controls">
        <input
          type="text"
          placeholder="Пошук продуктів..."
          value={searchTerm}
          onChange={handleSearchChange}
          className="search-input"
        />

        <select onChange={handleSortChange} value={sortOption} className="sort-select">
          <option value="">Без сортування</option>
          <option value="price-asc">Ціна (зрост.)</option>
          <option value="price-desc">Ціна (спад.)</option>
          <option value="name-asc">Назва (А–Я)</option>
          <option value="name-desc">Назва (Я–А)</option>
        </select>
      </div>

      <div className="products-list">
        {isLoading && <Loader/> }
        {error && <p>Помилка: {error}</p>}
        {!isLoading &&
          currentProducts.map((product) => (
            <div key={product._id} className="product-item">
              <button
                className="delete-button"
                onClick={() => handleDeleteProduct(product._id)}
              >
                Видалити
              </button>
              <ProductCard data={product} />
            </div>
          ))}
      </div>

      {totalPages > 1 && (
        <div className="pagination">
          {Array.from({ length: totalPages }, (_, index) => {
            const pageNumber = index + 1;
            return (
              <button
                key={pageNumber}
                className={`page-button ${
                  currentPage === pageNumber ? "active" : ""
                }`}
                onClick={() => handlePageChange(pageNumber)}
              >
                {pageNumber}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default AllProducts;
